import Vue from 'vue';
import vuetify from './plugins/vuetify';
import './plugins/constants_mixin';
import App from './App.vue'
import router from './router';
import Amplify from 'aws-amplify';
import awsConfig  from './aws-exports';
import {components} from 'aws-amplify-vue';
import store from './store/store'
import './plugins/google_maps'
import {Logger} from 'aws-amplify';
import {VueMaskDirective} from 'v-mask'
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

Vue.component('vue-phone-number-input', VuePhoneNumberInput);
Vue.directive('mask', VueMaskDirective);
Vue.config.productionTip = false
window.Vue = require('vue');

const isLocalhost = Boolean(
  window.location.hostname === "localhost" ||
    // [::1] is the IPv6 localhost address.
    window.location.hostname === "[::1]" ||
    // 127.0.0.1/8 is considered localhost for IPv4.
    window.location.hostname.match(
      /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
    )
);

// Assuming you have two redirect URIs, and the first is for localhost and second is for production
const [
  localRedirectSignIn,
  productionRedirectSignIn,
] = awsConfig.oauth.redirectSignIn.split(",");

const [
  localRedirectSignOut,
  productionRedirectSignOut,
] = awsConfig.oauth.redirectSignOut.split(",");

const updatedAwsConfig = {
  ...awsConfig,
  oauth: {
    ...awsConfig.oauth,
    redirectSignIn: isLocalhost ? localRedirectSignIn: productionRedirectSignIn,
    redirectSignOut: isLocalhost ? localRedirectSignOut : productionRedirectSignOut,
  }
}

Amplify.configure(updatedAwsConfig);

// Amplify.configure(awsConfig)


var vm = new Vue({
  el: '#app',
  store: store,
  router: router,
  vuetify: vuetify,
  data: {
    snackbar: false
  },
  template: '<App/>',
  components: {
    App,
    ...components
  },

})

let newWorker;

function showUpdateBar() {
  vm._data.snackbar = true
}

// The click event on the pop up notification
document.getElementById('reload').addEventListener('click', function () {
  newWorker.postMessage({action: 'skipWaiting'});
});

if ('serviceWorker' in navigator && process.env.NODE_ENV !== 'development') {
  navigator.serviceWorker.register('/OneSignalSDKWorker.js').then(reg => {
    reg.addEventListener('updatefound', () => {
      // A wild service worker has appeared in reg.installing!
      newWorker = reg.installing;

      newWorker.addEventListener('statechange', () => {
        // Has network.state changed?
        switch (newWorker.state) {
          case 'installed':
            if (navigator.serviceWorker.controller) {
              // new update available
              showUpdateBar();
            }
            // No update available
            break;
        }
      });
    });
  });

  let refreshing;
  navigator.serviceWorker.addEventListener('controllerchange', function () {
    if (refreshing) return;
    window.location.reload();
    refreshing = true;
  });
}



// WEBPACK FOOTER //
// ./src/main.js